import { Component, OnInit, Input, OnDestroy, Injector } from "@angular/core";
import {
	UserPermissionServiceProxy,
	AddressServiceProxy,
	UserPermissionAddressDto
	
} from "../../../../../../../../../shared/service-proxies/service-proxies";

import { ToRequestCityDto } from "../../../../../../../../../shared/service-proxies/service-proxies";
import { Subject, Observable, ReplaySubject, BehaviorSubject } from "rxjs";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { takeUntil, debounceTime } from 'rxjs/operators';
import { AppComponentBase } from '@shared/app-component-base';
import { TestService } from 'test/service/test.service';
import { CustomLocalizationService } from '@app/views/pages/transpop/utility/customLocalization.service';

enum methodName {
	keyPressAddress = 0,
	onClickLocation = 1
}

@Component({
	selector: "kt-to-request-static-sales-location",
	templateUrl: "./to-request-static-sales-location.component.html",
	styleUrls: ["./to-request-static-sales-location.component.scss"],
})

export class ToRequestStaticSalesLocationComponent extends AppComponentBase implements OnInit, OnDestroy {
	
	/** control for the MatSelect filter keyword */
	public addressSearchFilter: FormControl = new FormControl();

	/** list of banks filtered by search keyword */
	//public AddressList: ReplaySubject<StaticSalesmanAddressPto[]> = new ReplaySubject<StaticSalesmanAddressPto[]>(1);

	/** Subject that emits when the component has been destroyed. */
	protected _onDestroy = new Subject<void>();
	
	cities= new Subject<ToRequestCityDto[]>();


	//Dataları yayınladığımız değişken
	dynamicComponentObject = new Subject<any>();

	
    //Anlık olarak ngModel ile tutulan şehirleri combobox datasını yakalar
	selectedCity = new ToRequestCityDto();

	//Anlık olarak ngModel ile tutulan lokasyonları datasını yakalar
	selectedAddressObj = new UserPermissionAddressDto();

	 //Anlık olarak ngModel ile tutulan numaralrı  datasını yakalar
	selectedPhoneNumber: string = "";

	 //Anlık olarak ngModel ile tutulan  isimleri datasını yakalar
	selectedNameSurname = "";
	

	locationObjListByCity = new BehaviorSubject<UserPermissionAddressDto[]>([]);
	locationByCity: UserPermissionAddressDto[] = [];
	initialLocationByCity: UserPermissionAddressDto[] = [];

	//Kullanıcının nokta ve şahıs ikisine de yetkisi var ise
	//dataları kullanıcının ekranına combobox ile basıyoruz.
	orderTypes = [
		{ 'id': [5, 12], 'name': 'FE.ORDER.FORMS.COMBOBOX.TOREQUESTSALESSTATICLOCATION.ORDERTYPE.ALL'},
		{ 'id': [5], 'name': 'FE.ORDER.FORMS.COMBOBOX.TOREQUESTSALESSTATICLOCATION.ORDERTYPE.STATIC' },
		{ 'id': [12], 'name': 'FE.ORDER.FORMS.COMBOBOX.TOREQUESTSALESSTATICLOCATION.ORDERTYPE.LOCATION' },
	]

	selectedOrderType = this.orderTypes[0].id;

	constructor(
		injector: Injector,
		private _userPermissionService: UserPermissionServiceProxy,
		private _testService: TestService,
		private customLocalization: CustomLocalizationService
	) {
		super(injector);
	}
	
	ngOnInit() {

		this._testService.setTitle(this.customLocalization.l("FE.PAGEHEADERS.ORDER.TOREGIONWAREHOUSE.TOREQUESTSALESSTATICLOCATION.HEADER"));
		this._testService.setDesc(this.customLocalization.l("FE.PAGEHEADERS.ORDER.TOREGIONWAREHOUSE.TOREQUESTSALESSTATICLOCATION.SUBHEADER"));


		//Kullanıcı bazlı nokta ve sahış bilgilerinin getirildiği method.
		//this.RequestSalesStaticLocationByUserAuths(this.RelatedAuthIdList);

		//Kullanıcı bazlı nokta ve sahış bilgilerinin getirildiği method.
		//Hasan ve Burak Abi teyitli olarak değiştirildi.
		this.GetUserAssignedCityList();


		this.onKeyPressAddress();
	}
	
	//Kullanıcının hem sahıs hem de nokta yetkisi varsa bu method aktif bir method olur.
	//Nokta ya da Şahıs yada her ikisini seçebilir. Bu değişkliği buradan takip ediyoruz.
	onChangeOrderType() {

		//this.locationObjListByCity = new BehaviorSubject<UserPermissionAddressPto[]>([]);
		//this.locationByCity = [];
		////combobox içerisinde bir değişim oldupunda altta ki bazı yerleri sıfırlıyoruz.
		this.staticSalesItems(null, null, new BehaviorSubject<UserPermissionAddressDto[]>([]), []);
				
		this.GetUserAssignedCityList();
	}

	
	//////Burada ki kod optimize edilmeli güzel olmadı.
	//City bizim gösterilecek lokasyonlarımızı ve açık adreslerimizi belirleyecek olan yerdir.
	//Kullanıcı bir şehir seçtiği anda lokasyon bilgilerini buradan dolduruyoruz daha sonra
	//city yetkisi varsa extra olarak merge ediyoruz. ve adres listesini dolduruyoruz.
	onChangeCity() {

		this.staticSalesItems(this.selectedCity, null, new BehaviorSubject<UserPermissionAddressDto[]>([]), []);
	

		//şehir combosunda 'Seçiniz' tıklarsak adres combosunda ki içerisinde ki dataları boşalt diyoruz
		if (this.selectedCity) {

			this.getUserAssignedAddresses();

		}
		
		this.SendToObject();

	}

	onChangeNameSurname() {

		this.SendToObject();
	}

	//Lokasyon yerinde search combobox içerisinden bir lokasyonu seçtiğimizde bu method ile lokasyon bilgilerini alıyoruz.
	onChangeLocation() {
		
		//ve bilgileri güncelliyoruz.
		this.SendToObject()

	}


	isLocationNotFound: boolean = false;

	//Kullanıcı lokasyon arama kısmında yani search içerisinde bir tuşa bastığı anda bu işlemi yaptırıyoruz.
	onKeyPressAddress() {

		this.addressSearchFilter.valueChanges.pipe(debounceTime(500)).subscribe(result => {

			this.isLocationNotFound = false;

			//Bir şehir seçili ise gir diyoruz.
			if (this.selectedCity.cityId) {

				//Eğer bir adres seçili ise ve result null ise aşağıda ki işlemleri yapma diyoruz.
				//Bu sayede eski seçili olan yeni bir arama yapılana kadar kalıyor.
				if (this.selectedAddressObj && result == "") {
					return;
				}

				//eğer bir adres seçilmemiş ise ve aranacak bir kelime girilmediyse
				//ilk anda yüklenen datayı yükle diyoruz.
				if (result == "") {
					this.locationObjListByCity.next(this.initialLocationByCity);

				}

				//bir kelime aranmış ise yani adres aranmış ve kelime uzunluğu 3 den küçükse
				//ilk anda ki tüm datayı içeri bas diyoruz.
				if (result != "" && this.addressSearchFilter.value.trim().length < 3) {

					return this.locationObjListByCity.next(this.initialLocationByCity);
				}

				//search comobobox bir kelime yazılmış ise ve bu kelime 3 den küçükse içeri girme diyoruz.
				//aslında bu koşula ihtiyaçda yok gibi, bunu kaldırıp test edilecek.
				let searchLocation = this.addressSearchFilter.value.trim();
				if (searchLocation.length < 3) {

					return;
				}

				this._userPermissionService
					.getUserCitiesAddressWithUserAssignedAddresses(this.selectedOrderType, this.selectedCity.cityId, this.addressSearchFilter.value)
					.subscribe(resp => {

						if (resp.addresses.length < 1) {

							this.isLocationNotFound = true;
						}

						this.locationObjListByCity.next(resp.addresses);
						this.locationByCity = resp.addresses;

						this.selectedAddressObj = null;
						this.SendToObject();

						

					});

			}

		})

		




		//this.getLocationObjListByCity(methodName.keyPressAddress);





		//var addressObj = this.locationObjListByCity.getValue().filter(x => x.name);
		//if (addressObj.length < 1) {
		//	this.selectedAddressObj = null;
		//}

	}
	
	onClickLocation() {

		if (this.locationObjListByCity.getValue().length < 1) {
			this.locationObjListByCity.next(this.initialLocationByCity);

		}

		//this.getLocationObjListByCity(methodName.onClickLocation);
		
	}
	
	preValue: string = "";
	onKeyupPhoneMask() {

		////////////////////////////////////////////



		let newVal = this.selectedPhoneNumber.replace(/\D/g, '');



		var start = this.selectedPhoneNumber.length;
		if (this.selectedPhoneNumber.length < this.preValue.length) {



			var lastChar: string = this.preValue.substr(this.preValue.length - 1);



			// this.message = 'Removing...'; //Just console
            /**while removing if we encounter ) character,
            then remove the last digit too.*/
			if (this.preValue.length < start) {
				if (lastChar == ")") {
					newVal = newVal.substr(0, newVal.length - 1);
				}
			}
			//if no number then flush
			if (newVal.length == 0) {
				newVal = "";
			} else if (newVal.length <= 3) {
                /**when removing, we change pattern match.
              "otherwise deleting of non-numeric characters is not recognized"*/
				newVal = newVal.replace(/^(\d{0,3})/, "($1");
			} else if (newVal.length <= 6) {
				newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, "($1) $2");
			} else {
				newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, "($1) $2-$3");
			}



		}
		else {




			// don't show braces for empty value
			if (newVal.length == 0) {
				newVal = "";
			}
			// don't show braces for empty groups at the end
			else if (newVal.length <= 3) {
				newVal = newVal.replace(/^(\d{0,3})/, "($1)");
			} else if (newVal.length <= 6) {
				newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, "($1) $2");
			} else {
				newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, "($1) $2-$3");
			}

		}
		this.preValue = newVal;
		this.selectedPhoneNumber = newVal;


		////////////////// Önceki Hali ////////////////////

		//if (this.selectedPhoneNumber.length < 17) {

		//	let newVal = this.selectedPhoneNumber.replace(/\D/g, '');

		//	if (newVal.length === 0) {
		//		newVal = '';
		//	} else if (newVal.length <= 3) {
		//		newVal = newVal.replace(/^(\d{0,3})/, '($1)');
		//	} else if (newVal.length <= 6) {
		//		newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) ($2)');
		//	} else if (newVal.length <= 10) {
		//		newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) ($2)-$3');
		//	} else {
		//		newVal = newVal.substring(0, 10);
		//		newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) ($2)-$3');
		//	}

		//	this.selectedPhoneNumber = newVal;
		//}
		
	}
	
	onChangePhoneNumber() {
		
		var phoneNumber = this.selectedPhoneNumber;

		if (phoneNumber.length != 14) {
			this.selectedPhoneNumber = null;

			this.uiMessage.modal.warning("", this.customLocalization.l("FE.ALERTMESSAGES.STOCK.FORMS.PHONELENGTH"), null);
			//alert("Lütfen 10 haneli bir numara giriniz");
		}
		
		//ve değişen bilgileri yayınlıyoruz.
		this.SendToObject();
	}


	//Gönderilecek olan datalarımızı burada yayıncıya ekleriz.
	private SendToObject() {

		this.dynamicComponentObject.next({
			
			targetAddressObject: this.selectedAddressObj,
			salesPhone: this.selectedPhoneNumber,
			salesUserName: this.selectedNameSurname,
		});
	}

	//iki methodda kullanıyoruz adres ararken ve comboya ilk tıkladığımızda çalışır.
	private getLocationObjListByCity(methodNm) {

		// get the search keyword
		let search = this.addressSearchFilter.value;

		if (search != "" && (methodName.onClickLocation == methodNm)) {
			return;
		}

		search = search.toLocaleUpperCase('tr-TR');
		// filter the banks
		this.locationObjListByCity.next(
			this.locationByCity.filter(locationName => {

				//locationName.name.toLowerCase().indexOf(search) > -1
				//lokasyon adı ile aranan kelimeler arasında uyum varsa buraya gir be uyan isimleri next içerisine ata diyoruz.
				if (locationName.name.indexOf(search) > -1) {
					return locationName.name.indexOf(search) + 1;
				}
				//Eğer arana kelimeyle uyuşan bir data yokda lokasyonda birşey gösterme diyoruz.
				else {
					this.selectedAddressObj = null;
					this.SendToObject();

				}
			})
		);

	}

	//o müşteriye atanmış şehirlerin listesini getir diyoruz
	private GetUserAssignedCityList() {

		this._userPermissionService.getUserAssignedCityList(this.selectedOrderType)
			.subscribe((cityList) => {

				this.cities.next(cityList);
			})

	}

	//ilgili şehire atanmış adreslerin listesini getir diyoruz ve adres combosuna asenkro olarak dolduruyoruz.
	private getUserAssignedAddresses() {

		this._userPermissionService
			.getUserCitiesAddressWithUserAssignedAddresses(this.selectedOrderType, this.selectedCity.cityId, "")
			.subscribe(resp => {

				this.locationObjListByCity.next(resp.addresses);
				this.locationByCity = resp.addresses;
				this.initialLocationByCity = resp.addresses;
			});
	}


	private staticSalesItems(selectCity, selectAddresObj, locationObjListByCity, locationByCity) {
		this.selectedCity = selectCity;
		this.selectedAddressObj = selectAddresObj;

		this.locationObjListByCity = locationObjListByCity;
		this.locationByCity = locationByCity;

		this.SendToObject();

	}

	ngOnDestroy() {
		this._testService.setTitle(" ");
		this._testService.setDesc(" ");

		this._onDestroy.next();
		this._onDestroy.complete();
		this.cities.unsubscribe();
		this.dynamicComponentObject.unsubscribe();

	}
}
